import React, { Component } from 'react';
import { ListSection } from './ListItem'

import "./EventsOverview.css"

class EventsOverview extends Component{

  componentWillMount(){
    var events = window.events
    if (!events) {
      events = []
      events.push({"maxParticipants":3000,"minParticipants":1000,"companyName":"Tradono","locationType":"Indendørs","categoryTitle":"Markeder","id":783,"title":"Tradono Market at Train","description":"Tag din ven og veninde, kæreste, eller familie under armen og kig forbi til secondhand shopping med musik i baggrunden i fede lokaler på Train i Aarhus, 11-16.\n\n#TRADONOMARKET er et moderne loppemarked med kun det bedste secondhand modetøj, sko og accessories til mænd og kvinder. Markedet består af fashionable stader, som er nøje udvalgt blandt Danmarks bedste modebloggere, instagrammere, stilbevidste personer, brugere på Tradono m.fl. Markedet har tidligere været afholdt bl.a. på Israels Plads og Docken i København og på Godsbanen i Aarhus, hvor stadeholderne har i gennemsnit solgt for 4.000 kr.\n\nKOM MED! For kun 30 kr. kan du komme med til en hel dag med secondhand shopping. Når man shopper secondhand er der dobbelt på indholdet i poserne, op samvittigheden forbliver ren. Kom og vær en del af kampen mod tøjspild, og få dig en opdateret garderobe samtidig.\nSpørgsmål omkring vores markeder kan stilles på event@tradono.com, eller på vores facebook side: Tradono Market", "price":30,"fee":0,"time":1490518800,"address":"Toldbodgade 6","floor":"","city":"Aarhus","zipcode":"8000","company":true,"cvr":"","deadline":1490468400,"lang":0,"location":{"lat":56.152286,"lon":10.212074},"isFree":false,"image":"https://lh3.googleusercontent.com/bbgFazCH-Zjmiiwe68NI0RTt55o_kqfZ_zOUiKtRD8kBJwM2IePXqTaujGrkFFhrL0VQCfP9LDZ-fJlCJDxsTlo","link":"https://vildmad.gojoin.dk/aktivitet/783"})
    }

    this.setState({
      events:events
    })

    var date = new Date()

  this.getLocation()
    .then((loc)=>this.setState({
      location:loc
    }))
    .catch((err)=>console.log(err))

  }

  getLocation = () => {
    return new Promise(function(resolve, reject){
        if(navigator.geolocation){
          navigator.geolocation.getCurrentPosition(
            position=>{
            resolve(position);
          },
          err=>reject(err));
        }else{
          (reject("Current location not supported in this browser. Please enter the city."))
        }
    })
  }


  render(){
    return(
      <div>
        <ListSection
          items=
        {this.state.events.map((e, i)=>
            <Event
              {...e}
              key={i}
              curLocation={this.state.location}
              />
          )}>
      </ListSection>
      </div>
    )
  }
}

export default EventsOverview;

class Event extends Component{


    componentWillMount(){
      this.setState({
        loaded: this.props.image ? false : true
      })
    }

    componentWillReceiveProps(nextProps){
      if(nextProps.curLocation){
        var d = this.calculateDistance(
          nextProps.curLocation.coords.latitude,
          nextProps.location.lat,
          nextProps.curLocation.coords.longitude,
          nextProps.location.lon
        )
        this.setState({
          distance: d
        })
      }
    }

    calculateDistance = (lat1,lat2,lon1,lon2) =>{
        function deg2rad(deg) {
          return deg * (Math.PI/180)
        }
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2-lat1);  // deg2rad below
        var dLon = deg2rad(lon2-lon1);
        var a =
          Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
          Math.sin(dLon/2) * Math.sin(dLon/2)
          ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        var d = R * c; // Distance in km
        if (d >= 5) {
          d = d.toFixed(0)
        }else{
          d = d.toFixed(1)
        }
        return d;
    }


    onImageLoad=()=>{
      this.setState({
        loaded:true
      })
    }

  render(){
    return(
            <a className="event-preview" href={this.props.link}>
                  <div
                    className={"responsive-img " + (this.state.loaded ? "loaded" : "")}  style={{backgroundColor: "white"}}>
                    <img
                      alt={this.props.title}
                      onLoad={this.onImageLoad} src={this.props.image}/>
                    <div className="event-facts">
                      <div>
                        <p>
                          {this.props.price === 0 ?
                            (window.freeLabel || "Gratis")
                            :
                            (window.priceLabel || "Pris: ") + this.props.price + (window.currencyLabel || " DKK")
                          }
                        </p>
                      </div>
                      <div>
                        <p>Max: {this.props.maxParticipants + (window.participantsLabel || " deltagere")} </p>
                      </div>
                      <div>
                        <p>{this.props.locationType}</p>
                      </div>
                      <div>
                        <p>{this.props.categoryTitle}</p>
                      </div>
                    </div>
              </div>
              <div className="preview-bottom">
                <h4>
                  {this.props.title}
                </h4>
                <p className="location">
                  {this.props.city}
                </p>
                <p className="location-distance">
                  {this.state.distance ? (this.state.distance + (window.distanceLabel || " km væk") ) : ""}
                </p>
                <div className="div">
                  <p style={{float:"right"}}>
                    {new Date(this.props.time*1000).toLocaleDateString()}
                  </p>
                </div>
              </div>
          </a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/EventsOverview.js